"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
export class TableDefinition {
  constructor(component, config) {
    __publicField(this, "_config");
    __publicField(this, "component");
    __publicField(this, "renderSummary", false);
    __publicField(this, "columns");
    __publicField(this, "visibleColumns");
    __publicField(this, "tableClasses");
    __publicField(this, "headerRowClasses");
    __publicField(this, "rowKeyFn", () => "");
    __publicField(this, "emptyRowMessage", null);
    this._config = config;
    this.component = component;
    Object.assign(this, config);
    this.columns || (this.columns = []);
    this.visibleColumns = config && config.columns && config.columns.filter((x) => !x.hidden) || [];
  }
  renderTable(items, summary) {
    return /* @__PURE__ */ jsxs("table", { className: this.tableClasses, children: [
      this.renderHeaders(),
      /* @__PURE__ */ jsxs("tbody", { children: [
        this.renderRows(items),
        this.emptyRowMessage && items.length === 0 && this.renderNoItemsRow(),
        summary && this.rowSummary(summary)
      ] })
    ] });
  }
  renderHeaders() {
    return /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsx("tr", { className: this.headerRowClasses, children: this.visibleColumns.map((column, colIdx) => {
      return /* @__PURE__ */ jsx("th", { children: column.title }, `header-${colIdx}`);
    }) }) });
  }
  renderRows(items) {
    return _.map(items, this.renderRow.bind(this));
  }
  renderRow(item) {
    return this._renderRow(item, this.rowKeyFn(item), "render");
  }
  renderNoItemsRow() {
    const colCount = this.visibleColumns.length;
    return /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { colSpan: colCount, children: this.emptyRowMessage }) });
  }
  rowSummary(item) {
    if (!this.renderSummary) {
      return null;
    }
    return this._renderRow(item, void 0, "renderSummary");
  }
  _renderRow(item, rowKey, renderFn) {
    return /* @__PURE__ */ jsx("tr", { children: this.visibleColumns.map((column, colIdx) => {
      const render = (column[renderFn] || _.noop).bind(column);
      return /* @__PURE__ */ jsx("td", { children: render(item) }, `${rowKey}--${colIdx}`);
    }) }, rowKey);
  }
}
